import { ArrowRight } from 'lucide-react';
import { ChapterMark, FadeIn } from '../components/eclora/Reveal';

const DAYS = [
    'Où j\'en suis vraiment ?',
    'Ce que je ne veux plus',
    'Rencontre ta Future Toi',
    'Une habitude à la fois',
    'Reprends ton temps',
    'Fais ce que tu repousses',
    'Ton nouveau chapitre commence',
];

const METHOD = ['Imagine', 'Aligne', 'Agis', 'Éclos'];

export default function Journey() {
    return (
        <section className="px-6 py-20 sm:px-10 lg:py-32" data-testid="journey-section">
            <div className="mx-auto max-w-4xl">
                <ChapterMark index="03" label="Le parcours" />
                <FadeIn className="text-center">
                    <h2 className="font-serif text-3xl font-medium text-bordeaux sm:text-4xl lg:text-5xl">
                        Ton parcours Reset Éclora
                    </h2>
                </FadeIn>

                <div className="mt-14 border-t border-champagne/30" data-testid="day-journey-container">
                    {DAYS.map((title, i) => (
                        <FadeIn key={title} delay={0.05 * i} y={18}>
                            <div
                                className="group flex items-baseline gap-5 border-b border-champagne/30 py-5 transition-colors duration-500 hover:bg-nude/10 sm:gap-10 sm:py-6"
                                data-testid={`day-row-${i + 1}`}
                            >
                                <span className="eyebrow w-16 shrink-0 sm:w-20">Jour {i + 1}</span>
                                <span className="font-serif text-4xl font-light text-champagne/50 transition-colors duration-500 group-hover:text-champagne sm:text-5xl">
                                    {String(i + 1).padStart(2, '0')}
                                </span>
                                <h3 className="font-serif text-xl text-cacao transition-colors duration-500 group-hover:text-bordeaux sm:text-2xl">
                                    {title}
                                </h3>
                            </div>
                        </FadeIn>
                    ))}
                </div>

                <FadeIn delay={0.2} className="mt-14">
                    <div className="flex flex-wrap items-center justify-center gap-3 border border-champagne/40 bg-white/60 px-6 py-6 sm:gap-5 sm:py-7" data-testid="method-strip">
                        <span className="eyebrow mr-2 w-full text-center sm:w-auto">La méthode</span>
                        {METHOD.map((step, i) => (
                            <span key={step} className="flex items-center gap-3 sm:gap-5">
                                <span className="text-serifit text-xl text-bordeaux sm:text-2xl">{step}</span>
                                {i < METHOD.length - 1 && (
                                    <ArrowRight className="h-4 w-4 text-champagne" strokeWidth={1.5} aria-hidden="true" />
                                )}
                            </span>
                        ))}
                    </div>
                </FadeIn>
            </div>
        </section>
    );
}
